/**
 * Suspense fallback shown while a lazily-loaded route chunk is fetched.
 * Kept intentionally lightweight — the AppShell chrome (sidebar/header)
 * stays mounted around it, so this only fills the routed content area.
 */
export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-full items-center justify-center text-sm text-text-muted"
    >
      Loading…
    </div>
  );
}
